import { render, staticRenderFns } from "./MagicInfoServerStats.vue?vue&type=template&id=b44ec88a&scoped=true&"
import script from "./MagicInfoServerStats.vue?vue&type=script&lang=js&"
export * from "./MagicInfoServerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44ec88a",
  null
  
)

export default component.exports